import type { ComponentProps, CSSProperties } from 'react';
import { dropdownIconFor, dropdownIconMask, type DropdownIconName } from './dropdown-icons';

export type NativeSelectProps = ComponentProps<'select'> & { icon?: DropdownIconName | false };

/** A real select: labels, refs, native events, validation and FormData stay intact. */
export function NativeSelect({ icon, style, children, ...props }: NativeSelectProps) {
  const context = `${props['aria-label'] ?? ''} ${props.name ?? ''} ${props.id ?? ''}`;
  const resolved = icon === false || props.multiple || (props.size && props.size > 1)
    ? undefined : icon ?? dropdownIconFor(context);
  return <select {...props} data-slot="native-select" data-dropdown-icon={resolved}
    style={{ '--dropdown-icon-mask': resolved ? dropdownIconMask(resolved) : undefined, '--dropdown-padding-start': resolved ? '36px' : undefined, ...style } as CSSProperties}>
    {children}
  </select>;
}
